import { CalendarManager, Earnings, ISetParams } from '@benzinga/calendar-manager';
import { Session } from '@benzinga/session';
import { injectLogos } from '../lib/utils';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

const fetchEarnings = (
  session: Session,
  params: ISetParams = {},
  injectTickersLogos = true,
  pageSize = 100,
): Promise<Earnings[]> => {
  return session
    .getManager(CalendarManager)
    .getCalendarData('earnings', { ...params, pageSize })
    .then(async res => {
      if (res.ok) {
        const earnings = [...res.ok];
        earnings.sort((a: Earnings, b: Earnings) => {
          const dateA = new Date(a.date || 0).getTime();
          const dateB = new Date(b.date || 0).getTime();
          return dateB - dateA;
        });
        if (injectTickersLogos) {
          return (await injectLogos(earnings, session)) ?? earnings;
        }
        return earnings;
      }
      return [];
    })
    .catch(error => {
      logCalendarFetchFailure('earnings', error);
      return [];
    });
};

export { fetchEarnings };
